/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminBillListVo } from './AdminBillListVo';
import {
    AdminBillListVoFromJSON,
    AdminBillListVoFromJSONTyped,
    AdminBillListVoToJSON,
    AdminBillListVoToJSONTyped,
} from './AdminBillListVo';

/**
 * 
 * @export
 * @interface ResponseAdminBillListVo
 */
export interface ResponseAdminBillListVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdminBillListVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdminBillListVo
     */
    message?: string;
    /**
     * 
     * @type {AdminBillListVo}
     * @memberof ResponseAdminBillListVo
     */
    data?: AdminBillListVo;
}

/**
 * Check if a given object implements the ResponseAdminBillListVo interface.
 */
export function instanceOfResponseAdminBillListVo(value: object): value is ResponseAdminBillListVo {
    return true;
}

export function ResponseAdminBillListVoFromJSON(json: any): ResponseAdminBillListVo {
    return ResponseAdminBillListVoFromJSONTyped(json, false);
}

export function ResponseAdminBillListVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdminBillListVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdminBillListVoFromJSON(json['data']),
    };
}

export function ResponseAdminBillListVoToJSON(json: any): ResponseAdminBillListVo {
    return ResponseAdminBillListVoToJSONTyped(json, false);
}

export function ResponseAdminBillListVoToJSONTyped(value?: ResponseAdminBillListVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdminBillListVoToJSON(value['data']),
    };
}

